import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';
import IncorrectAnswersGrid from '../components/ResultsPage/IncorrectAnswersGrid';
import { IncorrectGuess } from '../types/game';
import { getRankFromScore } from '../utils/rankSystem';
import styles from './ResultsPage.module.css';

const ResultsPage: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {
        score,
        rounds,
        incorrectGuesses,
        isRanked,
        scoreMultiplier,
        artistCount,
    } = location.state as {
        score: number;
        rounds: number;
        incorrectGuesses: IncorrectGuess[];
        isRanked: boolean;
        scoreMultiplier: number;
        artistCount: number;
    };

    // scoreMultiplier already includes artist count multiplier from HomePage
    const rankedScoreValue = isRanked 
        ? score * scoreMultiplier
        : 0;
    const rankedScore = isRanked ? rankedScoreValue.toFixed(2) : null;
    const [isNewHighScore, setIsNewHighScore] = useState(false);

    useEffect(() => {
        if (isRanked && rankedScoreValue > 0) {
            const storedHighScore = localStorage.getItem('rankedHighScore');
            const currentHighScore = storedHighScore ? parseFloat(storedHighScore) : 0;

            if (rankedScoreValue > currentHighScore) {
                localStorage.setItem('rankedHighScore', rankedScoreValue.toString());
                localStorage.setItem('rankedHighScoreDate', new Date().toISOString());
                setIsNewHighScore(true);
            }
        }
    }, [isRanked, rankedScoreValue]);

    return (
        <PageLayout>
            <div className={styles.resultsContainer}>
                <h1>Game Over!</h1>
                <p className={styles.score}>Your final score is: {score} / {rounds}</p>
                {isRanked && (
                    <div 
                        className={styles.rankedScore}
                        style={{
                            background: getRankFromScore(rankedScoreValue).background,
                            borderColor: getRankFromScore(rankedScoreValue).borderColor,
                            boxShadow: `0 4px 12px ${getRankFromScore(rankedScoreValue).shadowColor}`,
                        }}
                    >
                        <div 
                            className={styles.rankTitle}
                            style={{ color: getRankFromScore(rankedScoreValue).textColor }}
                        >
                            {getRankFromScore(rankedScoreValue).name}
                        </div>
                        <p 
                            className={styles.multiplier}
                            style={{ 
                                color: getRankFromScore(rankedScoreValue).textColor,
                                background: 'rgba(0, 0, 0, 0.1)',
                                border: 'none'
                            }}
                        >
                            Score Multiplier: {scoreMultiplier.toFixed(2)}x
                        </p>
                        <p 
                            className={styles.multiplier}
                            style={{ 
                                color: getRankFromScore(rankedScoreValue).textColor,
                                background: 'rgba(0, 0, 0, 0.1)',
                                border: 'none'
                            }}
                        >
                            Artist Pool: {artistCount} artists
                        </p>
                        <p 
                            className={styles.finalRanked}
                            style={{ 
                                color: getRankFromScore(rankedScoreValue).textColor,
                                textShadow: getRankFromScore(rankedScoreValue).textColor === '#fff' 
                                    ? '2px 2px 4px rgba(0, 0, 0, 0.3)' 
                                    : 'none'
                            }}
                        >
                            <strong>Ranked Score: {rankedScore}</strong>
                            {isNewHighScore && <span className={styles.newHighScore}> 🎉 NEW HIGH SCORE!</span>}
                        </p>
                    </div>
                )}
                <button className={styles.button} onClick={() => navigate('/')}>
                    Play Again
                </button>
            </div>
            <IncorrectAnswersGrid incorrectGuesses={incorrectGuesses} />
        </PageLayout>
    );
};

export default ResultsPage; 